export default __webpack_public_path__ + "static/media/link-active.ba6cdf0c.svg";